import { useMemo } from 'react';
import useMeQuery from '../../hooks/api/useMeQuery';
import AuthContext from './AuthContext';

const AuthProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { data, error, isLoading } = useMeQuery();
  const me = data ?? null;

  const value = useMemo(() => {
    const isAuthenticated = isLoading ? null : me != null && error == null;
    return { isAuthenticated, me };
  }, [me, isLoading, error]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
